export const height = {
    desktop: 80,
    mobile: 82,
};
